
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

export function toggleSidebar(show:boolean) {

    return {
        type: TOGGLE_SIDEBAR,
        payload: show
    }
}